var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-add-page"},[_c('pageTitle',{attrs:{"pageTitle":_vm.$route.query.examId ? '编辑' : '创建'}}),_c('div',{staticClass:"exam-create-edit"},[_c('div',{ref:"ExamCreate"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }